import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import Loader from "../common/Loader";

import nataloBackground from "../assets/images/natalo.png";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { login, loading: authLoading } = useAuth();

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await login(username, password);
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Credenziali non valide. Riprova.");
      console.error("Login page error:", err);
    }
  };

  return (
    <div
      className="flex w-full items-start justify-start min-h-screen"
      style={{
        backgroundImage: `url(${nataloBackground})`,
        backgroundSize: '100% 100%',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        paddingLeft: '38vw',
        paddingTop: '58vh',
        paddingBottom: '10vh',
        margin: 0,
      }}
    >
      <div className="w-full max-w-sm rounded-2xl p-5 sm:p-6 bg-[#031c1c]/80 border border-[#5debd8]/40 shadow-[0_25px_65px_rgba(0,0,0,0.55)] backdrop-blur-xl">
        <form onSubmit={handleLoginSubmit} className="space-y-3">
          <div>
            <input
              id="username"
              name="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={authLoading}
              placeholder="Username"
              className="w-full px-4 py-2.5 rounded-xl border transition-all focus:outline-none focus:ring-2 bg-transparent border-[#5debd8]/40 text-white placeholder-[#ffd4ff]/70 focus:ring-[#ff5df0] focus:border-[#ff5df0] text-sm tracking-wide"
            />
          </div>
          
          <div>
            <input
              id="password"
              name="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={authLoading}
              placeholder="Password"
              className="w-full px-4 py-2.5 rounded-xl border transition-all focus:outline-none focus:ring-2 bg-transparent border-[#5debd8]/40 text-white placeholder-[#ffd4ff]/70 focus:ring-[#ff5df0] focus:border-[#ff5df0] text-sm tracking-wide"
            />
          </div>

          {error && !authLoading && (
            <p className="text-xs text-center text-[#ffb2f8]">{error}</p>
          )}
          
          <button 
            type="submit" 
            className="w-full py-2.5 px-4 rounded-xl font-semibold tracking-wide transition-all focus:outline-none bg-[#ff5df0] hover:bg-[#ff7df3] text-[#031414] shadow-[0_12px_30px_rgba(255,93,240,0.4)] focus:ring-2 focus:ring-[#ffb2f8] focus:ring-offset-2 focus:ring-offset-[#022020]"
            disabled={authLoading}
          >
            {authLoading ? (
              <span className="flex items-center justify-center gap-2">
                <Loader />
              </span>
            ) : 'Accedi'}
          </button>
        </form>
      </div>
    </div>
  );
}